import { render, staticRenderFns } from "./NovaTurmaExternaRow.vue?vue&type=template&id=01176a4f&scoped=true&"
import script from "./NovaTurmaExternaRow.vue?vue&type=script&lang=js&"
export * from "./NovaTurmaExternaRow.vue?vue&type=script&lang=js&"
import style0 from "./NovaTurmaExternaRow.vue?vue&type=style&index=0&id=01176a4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01176a4f",
  null
  
)

export default component.exports